module.exports = __webpack_public_path__ + "static/fr-b9bb8f1d7178e880e16d29ed4f8aea0a.webm";